/**
 * The landing world dot map — world-atlas land-110m rasterized in MERCATOR,
 * the projection the Figma landing map is drawn in (15:1412, `image 5`,
 * 786×492 → aspect 1.60). It is its OWN grid: 76 square cells across
 * lon −168…180, 48 rows for lat 82…−56 (no Antarctica), aspect
 * 1.58. The dot pitch on the page is whatever the map's width divides into
 * (76 columns); it has no relation to the page background.
 *
 * Characters: "." water, "1" land, "2" highlighted region (Europe, North
 * America, South America, Australia). Regenerate with
 * `gen-world-dots-mercator.py <cols>` (session scratchpad; reads world-atlas'
 * land-110m.json from unpkg).
 */
export const WORLD_DOT_COLS = 76;
export const WORLD_DOT_ROWS = 48;
export const WORLD_DOT_GRID: string[] = [
  '.................11111.111111111.1..........................................',
  '................111111.11111111111.......................1..................',
  '................11.11.11111111111........1...............1..................',
  '................11111.11111111111......11................11.................',
  '............1.111.11.11111111111.......11..................1................',
  '............1....111.11111111111........11.................1................',
  '..........1.....111..11111111111...................1.......11...............',
  '...........111..111.....11111111.................1......111111.....1........',
  '.........2..............11111111........................11111...............',
  '.........222....2222.....1111111................1.....111111111.1...........',
  '.........2.222.2.222.....1111111................1....111111111111..111......',
  '.2222....2.2222.2.2211...1111111.........22........111111111111111111111....',
  '............2.22.2.2..111......111222222.....2211..1........................',
  '2..................21..11....11111222222............1.......................',
  '2222222222222222222.11...111...111.....22.22.2211111111111111111111111111111',
  '.2222222222222222.2..11...1...........22222222211111111111111111111111111111',
  '.222.22222222222....1.................222222222111111111111111111111111.11..',
  '..2....222222222....222...............22..22222111111111111111111111...1....',
  '.2......2222222222..222............2..22.22222211111111111111111111....1....',
  '........22222222222222222...........2.222222222111111111111111111111...1....',
  '.........222222222222222.............222222222211111111111111111111.........',
  '..........2222222222222.............2222222222211111111111111111111.........',
  '..........2222222222222.............222.222..22.111111111111111111..........',
  '..........22222222222..............22.2.2222222..1111111111111111..1........',
  '..........2222222222...............2.....2.22221111111111111111.1...........',
  '...........22222222................1111.....1111111111111111111.............',
  '...........222222.2................111111111111.111111111111111.............',
  '.............22..................11111111111.111.11111111111111.............',
  '..............2..2...............11111111111111111..1111.111................',
  '...............22................111111111111.111....11..111................',
  '.................................1111111111111.......1....111...............',
  '....................2222..........11111111111111..........1....1............',
  '....................222222.............11111111..............1..............',
  '...................22222222............1111111...............1.1.1..........',
  '...................2222222222..........111111..............1...1...1111.....',
  '....................222222222...........11111........................2......',
  '....................22222222...........1111111.1................22..........',
  '.....................2222222...........111111.1................222222.......',
  '.....................222222.............1111..1...............22222222......',
  '.....................22222..............1111..................22222222......',
  '.....................22222...............11...................22222222......',
  '.....................222...........................................222....1.',
  '.....................222...................................................1',
  '.....................22.............................................2.....1.',
  '....................22...................................................1..',
  '....................22......................................................',
  '....................22.2....................................................',
  '.....................2......................................................',
];
